/**
 * Lejart emlekezteto - a valos ideju retegtol a felugro ablakig.
 *
 * Kulon kis busz, mint a huddle-nel: a `RealtimeProvider` es a felugro ablak
 * kozott nincs szulo-gyerek kapcsolat, es egy ilyen ritka esemeny miatt nem
 * eri meg a React-fat atrendezni.
 */
export interface DueReminder {
  reminderId: string;
  /** A KIKULDES azonositoja - a felugro ablakon ezzel megy a kipipalas. */
  deliveryId: string;
  text: string;
  creatorId: string;
  remindAt: string;
  /** Mentett elem emlekeztetoje: az uzenet helye (U7). */
  link?: { channelId: string; messageId: string };
}

type Handler = (reminder: DueReminder) => void;

const handlers = new Set<Handler>();

export function onReminderDue(handler: Handler): () => void {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export function emitReminderDue(reminder: DueReminder): void {
  for (const handler of handlers) handler(reminder);
}
